import { motion } from "framer-motion";
import { useI18n } from "@/i18n/I18nContext";

export default function Purpose() {
  const { t } = useI18n();
  return (
    <section className="py-24 md:py-32" data-testid="section-purpose">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-4">
            <div className="eyebrow">{t("purpose.eyebrow")}</div>
          </div>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="lg:col-span-8 font-serif-display text-4xl md:text-6xl leading-[1.02] tracking-tight text-[#0F172A]"
          >
            {t("purpose.title")}
          </motion.h2>
        </div>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.15 }}
          className="mt-10 max-w-4xl text-[#525866] text-lg leading-relaxed lg:ml-[33.333%]"
        >
          {t("purpose.paragraph")}
        </motion.p>
      </div>
    </section>
  );
}
